const getters = {
    token: state => state.common.token,
    name: state => state.common.name,
    permissions: state => state.common.permissions,
    shopDetail: state => state.common.shopDetail,
    navData: state => state.common.navData,
    notice: state => state.common.notice,
    my_reviews: state => state.common.my_reviews,
    notice_length: state => state.common.notice_length,
    isAdmin: state => state.common.isAdmin,
    userInfo: state => state.common.userInfo,
    wechatRandom: state => state.common.wechatRandom,
    globalButtonStatus: state => state.common.globalButtonStatus,
    selectUserList: state => state.common.selectUserList,
    navDataGroup: state => state.common.navDataGroup,
    navDataGroup_office: state => state.common.navDataGroup_office,
    navDataGroup_hr: state => state.common.navDataGroup_hr,
    navDataGroup_system: state => state.common.navDataGroup_system,
    activeModuldData: state => state.common.activeModuldData,
    activeModuldDataStat: state => state.common.activeModuldDataStat,
    currentPath: state => state.common.currentPath,
    activeModule: state => state.common.activeModule,
    permissionsPath: state => state.common.permissionsPath,
    _permissions: state => state.common._permissions,
    approvalStatic: state => state.common.approvalStatic,
    TimeRange: state => state.common.TimeRange,
    bankInfo: state => state.common.bank_info,
    publicStaticAll: state => state.common.publicStaticAll,
    adStaticAll: state => state.common.adStaticAll,
    oaStaticAll: state => state.common.oaStaticAll,
    colorList: () => {
        return [
            '#1890FF',
            '#13C2C2',
            '#9C54FF',
            '#CC86B6',
            '#6784FF',
            '#DAACE9',
            '#7599EE',
            '#D3F261',
            '#81CDB7',
            '#E2D58D',
            '#F1699B',
            '#69C0FF',
            '#ADC6FF',
            '#FFC069',
            '#95A5F4',
            '#FFF026',
            '#EB8DBC',
            '#C08DFF',
            '#FFB8A5',
            '#E68CC3',
            '#FFA749',
            '#FADB14',
            '#B7EB8F',
            '#85A5FF',
            '#AE6DCE',
            '#F17BFF',
            '#FFA999',
            '#ECDC48',
            '#A0D911',
            '#DBBBFF',
            '#809CFF',
            '#FF8B75',
            '#F975BA',
            '#FFC2BC',
            '#FFADD2',
            '#BAE7FF',
            '#FFCCAB',
            '#FFE398',
            '#FFA3A3',
            '#DEB1EB',
            '#B3DBA7',
            '#E7E2A2',
        ]
    }
};

export default getters;
